/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import type { StyleXStyles } from '@stylexjs/stylex';
import type { StyleOrFunction } from '../../types';

/** Resolves a component-specific style from a style object, handling both function and object inputs. */
const resolveComponentStyle = <TState>(
  style: StyleOrFunction<TState> | Record<string, StyleOrFunction<TState>> | undefined,
  state: TState,
  componentName: string,
): StyleXStyles | undefined => {
  if (!style) {
    return undefined;
  }

  const styleObject = typeof style === 'function' ? style(state) : style;

  if (componentName === 'base' && styleObject && typeof styleObject === 'object' && !(componentName in styleObject)) {
    return styleObject as StyleXStyles;
  }

  if (styleObject && typeof styleObject === 'object' && componentName in styleObject) {
    const componentStyle = (styleObject as Record<string, StyleOrFunction<TState>>)[componentName];
    return typeof componentStyle === 'function' ? componentStyle(state) : componentStyle;
  }

  return null;
};

export { resolveComponentStyle };
